// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"aa75b5d5","78":"58a2209c","133":"26d908ab","169":"2c4879cb","180":"a25d1b8e","276":"f67f7a90","624":"8f259c4e","848":"b131d845","901":"42d029f0","921":"15831b09","923":"a77d8edb"}[chunkId] + ".chunk.js";
};